import {  CommonModule  } from '@angular/common';
import {  Component     ,
          Input         } from '@angular/core';
import {  TranslatePipe } from 'nv@services/translate.service';

@Component({
  selector    : 'template-cost-operation-mini',
  templateUrl : './template-cost-operation-mini.component.html',
  imports     : [ CommonModule, TranslatePipe ]
})
export class TemplateCostOperationMini {

  @Input() public inputData: any;
  @Input() public inputIsVisible = false
}
